<template>
  <div>


    <div class="footer-page" v-if="!isMobile">
      <div class="SYLPFooter">
        <div class="footer-container">
          <div class="footer-title">
            <img class="logoSvg" src="@/assets/images/logo.svg" alt="尚艺良品">
            <h4>
              <span>装配式装修全生命周期服务商</span>
              <span>中国装配式装修共创首选合作伙伴</span>
            </h4>
          </div>
          <div class="footer-description">
            <div class="listGroup">
              <ul>
                <li>
                  <div class="descTag">
                    <div class="tagBox label"><i>2</i></div>
                    <span>个定位</span>
                  </div>
                  <p>· 装配式内装全生命周期服务商</p>
                  <p>· 存量旧改翻新供应链服务平台</p>
                </li>
                <li>
                  <div class="descTag">
                    <div class="tagBox label"><i>2</i></div>
                    <span>大能力</span>
                  </div>
                  <p>· 装配式内装全部品体系研发能力</p>
                  <p>· 数字化交付全流程服务技术能力</p>
                </li>
                <li>
                  <div class="descTag">
                    <div class="tagBox label"><i>2</i></div>
                    <span>个市场</span>
                  </div>
                  <p>· 深耕酒店营建市场</p>
                  <p>· 聚焦城市存量翻新</p>
                </li>
              </ul>
              <ul>
                <li>
                  <div class="descTag">
                    <div class="tagBox label"><i>3</i></div>
                    <span>类业务</span>
                  </div>
                  <h5>1. 装配内装部品体系研发</h5>
                  <p>· 部品构件开发</p>
                  <p>· 系统集成开发</p>
                  <p>· 装配深化开发</p>
                </li>
                <li>
                  <div class="descTag">
                    <div class="tagBox"><i></i></div>
                    <span></span>
                  </div>
                  <h5>2. 装配内装部品部件供应</h5>
                  <p>· 通用部品部件</p>
                  <p>· 专用部品部件</p>
                  <p>· 标准物料供应</p>
                </li>
                <li>
                  <div class="descTag">
                    <div class="tagBox"><i></i></div>
                    <span></span>
                  </div>
                  <h5>3. 城市存量旧改翻新服务</h5>
                  <p>· 存量酒店翻新</p>
                  <p>· 家装旧房翻新</p>
                  <p>· 办公商业翻新</p>
                </li>
              </ul>
            </div>
            <div class="callMe">
              <h4>联系我们</h4>
              <h5>关注尚艺良品公众号、小程序，可获取更多动态资讯</h5>
              <div class="wxCode">
                <img src="@/assets/images/ewm.svg" alt="">
                <img src="@/assets/images/xcx.svg" alt="">
              </div>
              <div class="phone">咨询热线：400-836-1633</div>
              <button class="contactUs" @click="contactUsBtn">联系我们</button>
            </div>
          </div>
          <div class="networkFiling">
            <h4>
              <div class="mt8">
                <p>苏ICP备15061863号
                  <span>
                    <img class="beian" src="@/assets/images/备案图标.png" alt="">
                    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32010602011671" rel="noreferrer" target="_blank">苏公网安备32010602011671</a>
                  </span>
                </p>
              </div>
              <span>总部研发中心：南京市鼓楼区丁家桥30号·南京工业大学国家大学科技园</span>
            </h4>
            <h4>
              <span>© 2024 尚艺良品 SUNYWONDERS.COM 保留所有权利</span>
              <span>华东部品基地：安徽省宣城市郎溪县复兴中路04号·苏皖创新示范工业园</span>
            </h4>
          </div>
        </div>
      </div>

    </div>

    <div class="isMobile-page" v-if="isMobile">
      <div class="wrapper">
        <div class="footer-container">
          <div class="footer-description">
            <div class="listGroup">
              <div>
                <div class="footerItem">
                  <div class="descTag">
                    <div class="tagBox label"><i>2</i></div>
                    <span>个定位</span>
                  </div>
                  <div class="desText mb5">· 装配式内装全生命周期服务商</div>
                  <div class="desText">· 存量旧改翻新供应链服务平台</div>
                  <div></div>
                </div>
                <div class="footerItem">
                  <div class="descTag">
                    <div class="tagBox label"><i>2</i></div>
                    <span>大能力</span>
                  </div>
                  <div class="desText mb5">· 装配式内装全部品体系研发能力</div>
                  <div class="desText">· 数字化交付全流程服务技术能力</div>
                </div>
              </div>
              <div>
                <div class="footerItem">
                  <div class="descTag">
                    <div class="tagBox label"><i>2</i></div>
                    <span>个市场</span>
                  </div>
                  <div class="desText mb5">· 深耕酒店营建市场</div>
                  <div class="desText">· 聚焦城市存量翻新</div>
                </div>
              </div>
            </div>
            <div class="business mb32">
              <div>
                <div class="descTag">
                  <div class="tagBox label"><i>3</i></div>
                  <span>类业务</span>
                </div>
                <div class="desText mb5">1. 装配内装部品体系研发</div>
                <p>· 部品构件开发</p>
                <p>· 系统集成开发</p>
                <p>· 装配深化开发</p>
              </div>
              <div class="inner">
                <div class="descTag ">
                  <div class="tagBox"><i></i></div>
                  <span></span>
                </div>
                <div class="desText mb5">2. 装配内装部品部件供应</div>
                <p>· 通用部品部件</p>
                <p>· 专用部品部件</p>
                <p>· 标准物料供应</p>
              </div>
              <div class="inner">
                <div class="descTag">
                  <div class="tagBox"><i></i></div>
                  <span></span>
                </div>
                <div class="desText mb5">3. 城市存量旧改翻新服务</div>
                <p>· 存量酒店翻新</p>
                <p>· 家装旧房翻新</p>
                <p>· 办公商业翻新</p>
              </div>
            </div>
          </div>
          <div class="callMe">
            <h4>联系我们</h4>
            <h5 class="mb16">关注尚艺良品公众号、小程序，可获取更多动态资讯</h5>
            <div class="wxCode">
              <img src="@/assets/images/ewm.svg" alt="">
              <img class="ml24" src="@/assets/images/xcx.svg" alt="">
            </div>
            <div class="mt24">
              <div class="mb16">
                <h5>总部研发中心：</h5>
                <div class="desText1">南京市鼓楼区丁家桥30号·南京工业大学国家大学科技园</div>
              </div>

              <div class="mb16">
                <h5>华东部品基地：</h5>
                <div class="desText1">安徽省宣城市郎溪县复兴中路04号·苏皖创新示范工业园</div>
              </div>

              <div class="flexBt">
                <div>
                  <h5>电话：</h5>
                  <div class="desText1">400-836-1633</div>
                </div>
                <div>
                  <h5>网址：</h5>
                  <div class="desText1">www.sunywonders.com</div>
                </div>
              </div>
            </div>
            <div class="callButtom" @click="contactUsBtn">联系我们</div>
          </div>
        </div>

      </div>
      <div class="networkFiling flexCenter">
        <div class="flexCenterC">
          <div>© 2024 尚艺良品 SUNYWONDERS.COM 保留所有权利</div>
          <div class="mt8">
            <p>苏ICP备15061863号
              <span>
                <img class="beian" src="@/assets/images/备案图标.png" alt="">
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32010602011671" rel="noreferrer" target="_blank">苏公网安备32010602011671</a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: 'TheFooter',
  computed: {
    ...mapState(["isMobile", "visibleHeight"]),
  },
  mounted() {
    this.handleSize()
    window.addEventListener('resize', this.handleSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleSize);
  },
  methods: {
    ...mapActions(['updateContactDialog']), // 映射 action
    handleSize() {
      this.$store.commit("setIsMobile", window.innerWidth <= 768);
      // console.log("🚀 ~ handleSize ~ window.innerWidth:", window.innerWidth);
    },
    contactUsBtn() {
      this.updateContactDialog(true); // 修改 contactDialog 的值为 true
    }
  }
}
</script>

<style lang="scss" scoped>
.mt8 {
  font-size: 12px;
  color: #818188;
  .beian {
    margin-right: 5px;
    margin-left: 15px;
    width: 15px;
    height: 15px;
    vertical-align: middle;
  }
  a {
    text-decoration: none;
    color: #818188;
  }
}

@media screen and (max-width: 768px) {
  .isMobile-page {
    background: #F7F8F9;

    .wrapper {
      padding: 24px 18px;
      margin: 0 auto;

      .footerItem {
        padding: 16px;
        margin-bottom: 12px;
        background: #FFFFFF;
        border-radius: 10px;
        box-shadow: 0 4px 18px 0 rgba(191, 191, 191, 0.18);
      }

      .descTag {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .tagBox {
          width: 26px;
          height: 26px;
        }

        .label {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #FFDE00;

          i {
            font-family: 'AntonFont', 'Microsoft YaHei', serif;
            font-size: 22px;
            font-weight: bold;
            line-height: 26px;
          }
        }

        span {
          margin-left: 10px;
          font-weight: bold;
          font-size: 16px;
          line-height: 21px;
        }
      }

      .desText1 {
        font-size: 12px;
        line-height: 16px;
        margin-top: 2px;
      }

      .desText {
        font-size: 12px;
        color: #666666;
        line-height: 18px;
      }

      .inner {
        margin-top: 14px;
        padding-top: 14px;
        border-top: 1px solid #EEEEEE;
      }

      .business {
        padding: 16px;
        background: #FFFFFF;
        border-radius: 10px;
        box-shadow: 0 4px 18px 0 rgba(191, 191, 191, 0.18);

        .desText {
          color: #000000;
          font-weight: 500;
        }

        .inner {
          .descTag {
            display: none;
          }
        }

        p {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          line-height: 20px;
        }
      }


      .callMe {
        padding: 32px 0;
        border-top: 1px solid #CCCCCC;

        .callButtom {
          width: 150px;
          height: 44px;
          line-height: 44px;
          text-align: center;
          background: #FF0053;
          border-radius: 23px;
          font-weight: bold;
          font-size: 16px;
          color: #FFFFFF;
          margin-top: 40px;
        }

        h4 {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 16px;
          color: #000000;
          margin-bottom: 4px;

        }

        h5 {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #666666;

        }

        img {
          width: 25vw;

        }
      }


    }

    .networkFiling {
      width: 100%;
      height: 60px;
      background: #1F1F1F;
      border-radius: 0px 0px 0px 0px;
      font-size: 10px;
      color: #818188;
      line-height: 12px;
    }
  }
}

@media screen and (min-width: 769px) {
  .footer-page {
    padding-bottom: 32px;

    .SYLPFooter {
      width: 1140px; // todo
      margin: 0 auto;
    }

    .footer-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #CCCCCC;
      padding-bottom: 30px;
      margin-top: 90px;

      .logoSvg {
        width: 120px;
        height: 96px;
      }

      h4 {
        text-align: right;
        font-size: 18px;
        line-height: 21px;
        font-weight: 400;

        span {
          display: block;

          &:last-child {
            margin-top: 10px;
          }
        }
      }
    }

    .footer-description {
      display: flex;
      margin-top: 40px;
      padding-bottom: 43px;
      border-bottom: 1px solid #CCCCCC;

      .listGroup {
        border-right: 1px solid #CCCCCC;
      }

      ul {
        display: flex;

        &:first-child {
          margin-bottom: 50px;

          li {
            margin-right: 60px;

            &:last-child {
              margin-right: 0;
            }
          }

          p {
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            margin-top: 10px;
          }
        }

        &:last-child {
          margin-right: 70px;

          li {
            &:nth-child(1) {
              margin-right: 94px;
            }

            &:nth-child(2) {
              margin-right: 108px;
            }
          }

          h5 {
            font-size: 14px;
            font-weight: 400;
            line-height: 16px;
            margin-top: 15px;
            margin-bottom: 5px;
          }

          p {
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            color: #666666;
          }
        }
      }

      .descTag {
        display: flex;

        .tagBox {
          width: 25px;
          height: 25px;
        }

        .label {
          border-radius: 50%;
          background: #FFDE00;
          position: relative;

          i {
            font-family: 'AntonFont', 'Microsoft YaHei', serif;
            position: absolute;
            top: -15px;
            left: 5px;
            font-size: $size32;
            font-weight: bold;
          }
        }

        span {
          margin-left: 10px;
          font-weight: bold;
          font-size: 18px;
          line-height: 21px;
        }
      }

      .callMe {
        margin-left: 77px;

        h4 {
          font-weight: bold;
          font-size: 24px;
          color: #000000;
          line-height: 28px;
        }

        h5 {
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          line-height: 16px;
          margin: 10px 0 25px;
        }

        .wxCode {
          img {
            width: 100px;
            height: 100px;

            &:last-child {
              margin-left: 40px;
            }
          }
        }

        .phone {
          font-weight: 400;
          font-size: 18px;
          line-height: 21px;
          margin: 20px 0 22px;
        }

        .contactUs {
          width: 160px;
          height: 46px;
          background: #FF0053;
          border-radius: 23px 23px 23px 23px;
          border: none;
          font-weight: bold;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 16px;
          cursor: pointer;

          &:hover {
            background: #ff3375;
          }

          &:active {
            background: #b3003a;
          }
        }
      }
    }

    .networkFiling {
      margin-top: 20px;

      h4 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      span {
        font-weight: 400;
        font-size: 12px;
        color: #818188;
        line-height: 14px;
      }
    }
  }
}
</style>
